import {useRealtimeNotifications} from '@common/notifications/use-realtime-notifications';

export function RealtimeNotifications() {
  useRealtimeNotifications();
  return null;
}
